import { envVariables } from '@/utils/envHelpers';

export type DeploymentMode = 'cloud' | 'offline';

export type RuntimeCapabilities = {
  readonly deploymentMode: DeploymentMode;
  readonly automaticAuthentication: boolean;
  readonly singleDevice: boolean;
  readonly organizationManagement: boolean;
};

export const createRuntimeCapabilities = (rawMode?: string): RuntimeCapabilities => {
  const deploymentMode: DeploymentMode = rawMode === 'offline' ? 'offline' : 'cloud';

  return {
    deploymentMode,
    automaticAuthentication: deploymentMode === 'offline',
    singleDevice: deploymentMode === 'offline',
    organizationManagement: deploymentMode === 'cloud',
  };
};

export const runtimeCapabilities = createRuntimeCapabilities(envVariables.APP_MODE);
